export const getBookingForm = [
    {
        name: 'firstname',
        label: 'Name',
        translateLabel: true,
        type: 'text'
    },
    {
        name: 'lastname',
        label: 'Surname',
        translateLabel: true,
        type: 'text'
    },
    {
        name: 'documentTypeId',
        label: 'Document Type',
        translateLabel: true,
        type: 'dropdown'
    },
    {
        name: 'documentNumber',
        label: 'documentNumber',
        translateLabel: true,
        type: 'text'
    },
    {
        name: 'email',
        label: 'Email',
        translateLabel: false,
        type: 'text'
    },
    {
        name: 'phoneNumber',
        label: 'Phone Number',
        translateLabel: true,
        type: 'text'
    }
]